import React from 'react';
import { FaCheck } from 'react-icons/fa';

const plans = [
  {
    name: 'Free',
    price: '₹ 0.00',
    features: ['Unlimited Users', 'Free Delivery App With Many Inhouse Users', 'COD Enabled', 'Basic Support'],
    available: true,
  },
  {
    name: 'Pro',
    price: '₹ 199.99',
    features: ['Unlimited Users', 'Free Delivery App With Many Inhouse Users', 'Online Payment UPI integration', 'Direct Money In Your UPI Account', 'Priority Support'],
    available: false, // Pro is not available
  },
  {
    name: 'Enterprise',
    price: '₹ 499.99',
    features: ['Unlimited Users', 'Free Delivery App With Many Inhouse Users', 'Online Payment UPI integration', 'Direct Money In Your UPI Account', 'Unlimited Delivery Support By TWARAM TPG WORLD', 'No Plateform Fee', 'Priority Support'],
    available: false, // Enterprise is not available
  },
];

function Pricing() {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6 text-center">Our Pricing Plans</h1>
      <div className="grid md:grid-cols-3 gap-8">
        {plans.map((plan) => (
          <div
            key={plan.name}
            className="border rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-2xl font-semibold mb-4">{plan.name}</h2>
            <p className="text-3xl font-bold mb-6">
              {plan.price}
              {plan.name !== 'Enterprise' && <span className="text-sm font-normal">/month</span>}
            </p>
            <ul className="space-y-2 mb-6">
              {plan.features.map((feature) => (
                <li key={feature} className="flex items-center">
                  <FaCheck className="h-5 w-5 text-green-500 mr-2" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
            {/* Conditional rendering for the button */}
            {plan.available ? (
              <button className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                Get Started
              </button>
            ) : (
              <button
                className="w-full bg-gray-300 text-gray-500 font-bold py-2 px-4 rounded cursor-not-allowed"
                disabled
              >
                Coming Soon!
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Pricing;
